<template>
  <div class="parts">
    <div class="filters">
      <span class="p-input-icon-left">
        <i class="pi pi-filter" />
        <InputText type="text" v-model="filterText" placeholder="Filter" />
      </span>
    </div>
    <div class="part_list">
      <div class="part" v-for="f in filteredParts" :key="f.id">
        <div class="p-d-flex p-jc-center">
          <div class="p-px-3">
            <h3 class="p-m-2">{{ f.admin }}</h3>
          </div>
        </div>

        <div class="desc">
                    <div>Notification:</div>
          <h3 class="p-text-uppercase p-m-0">{{ f.notification }}</h3>
        </div>

        <div class="item">
          <div>Part Description:</div>
          <b>{{ f.desc }}</b>
        </div>

                <div class="niin item">
          <div>Part niin:</div>
          <b>{{ f.niin }}</b>
        </div>

                <div class="qty item">
          <div>qty:</div>
          <b>{{ f.qty }}ea</b>
        </div>

        <div class="created item">
          <div>Date Requested:</div>
          <b>{{ formatDate(f.created) }}</b>
        </div>

        <div class="user item">
          <div>Requested by:</div>
          <b>{{ f.user.rank }} {{ f.user.lastname }},
            {{ f.user.firstname }}
          </b>
        </div>



        <Button
          type="button"
          label="Mark As Complete!"
          icon="pi pi-check-circle"
          class="p-button-warning p-mb-3"
          @click="confirmSubmit(f)"
        />



        <Dialog
          header="Warning"
          :visible="confirmSubmitDialog"
          :style="{ width: '350px' }"
          :modal="true"
        >
          <div class="confirmation-content">
            <i
              class="pi pi-exclamation-triangle p-mr-3"
              style="font-size: 2rem"
            />
            <span><b>THIS CANNOT BE UNDONE!</b><br/><br/>
            Only confirm yes if you have created this notification in GCSS-Army</span><br/><br/>
            Would you like to complete this PMCSx part?
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              @click="confirmSubmitDialog = false"
              class="p-button-text"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              @click="submitPart()"
              class="p-button-text"
              autofocus
            />
          </template>
        </Dialog>







      </div>
    </div>
  </div>
</template>

<script>
import { fb_db, fs } from "../firebase";
import { format } from "date-fns";
import Dialog from "primevue/dialog";

export default {
  name: "Newparts",
  components: {
    Dialog,
  },
  data() {
    return {
      parts: [],
      confirmSubmitDialog: false,
      filterText: "",
      selectedStatus: "Needs Ordered",
      form: {
        admin: null,
        notification: null,
        desc: null,
        created: null,
        niin: null,
        user: null,
        qty: null,
      },
    };
  },
  async mounted() {
    await this.getParts();
        this.loading = false;
  },
  methods: {
    async getParts() {
      this.loading = true;
      await fb_db
        .collection("parts").orderBy("notification")
        .get()
        .then((docs) => {
          this.parts = [];
          docs.forEach(async (doc) => {
            let item = doc.data();
            item.id = doc.id;
            let user = await item.user.get();
            item.user = user.data();
            this.parts.push(item);
          });
          this.loading = false;
        })
        .catch((error) => {
          console.error("error getting parts: ", error);
        });
    },
    formatDate(date) {
      let dt = date.toDate();
      return format(dt, "HH:mm MM/DD/YYYY");
    },
        confirmSubmit(part) {
      console.log("confirm submit");
      this.submitthispart=part
      this.confirmSubmitDialog = true;
    },
        submitPart() {
        console.log("Submit part: ", this.submitthispart.id);
        fb_db
          .collection("parts")
          .doc(this.submitthispart.id)
          .update({
            status: "Complete"
          })
          .then(() => {
            console.log("part successfully submitted");
            this.confirmSubmitDialog = null;
            this.getParts();
          })
          .catch((error) => {
            this.$toast.add({
              severity: "error",
              summary: "Error!",
              detail: error,
              life: 3000,
            });
            console.error("error submitting part: ", error);
          });
    },
  },
  computed: {
    filteredParts() {
      return this.parts.filter((f) => {
if (this.selectedStatus == "Needs Ordered") {
          return (
            f.status == "Needs Ordered" &&
            f.admin.toLowerCase().indexOf(this.filterText.toLowerCase()) > -1
          );
        } 
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/theme.scss";

.parts {
  .part_list {
    .part {
      width: 300px;

      background: #efefef;
      border-radius: 10px;
      margin: 10px;
      float: left;

      div {
        margin: 0px 5px;
        padding: 5px 15px;
        border-radius: 5px;
        // color: $white;
      }

      .edit {
        background: $accent;
        // color: $text;
        cursor: pointer;
      }

      .submit {
        background: $primary;
        // color: $white;
        cursor: pointer;
      }

      .item {
        padding: 5px;
        text-align: left;

        b {
          margin-left: 25px;
        }

        div {
          font-size: 14px;
        }
      }

      .admin {
      }

      .niin {
        color: black;
      }

      .desc {
        color: #000000;
      }

      .qty {
                color: black;
      }

      .repairstatus {

      }

      .created {
      }

      .user {
        color: black;
      }

      .assigned {
        color: red;
      }
    }
  }
}
</style>